export function digitsOnly(value: string): string {
  return value.replace(/\D/g, "");
}

export function formatPhoneInput(value: string): string {
  let digits = digitsOnly(value);
  if (digits.startsWith("55") && digits.length > 11) {
    digits = digits.slice(2);
  }
  digits = digits.slice(0, 11);
  if (!digits) return "";

  if (digits.length <= 2) return `(${digits}`;

  const areaCode = digits.slice(0, 2);
  const subscriber = digits.slice(2);
  if (!subscriber) return `(${areaCode})`;
  if (subscriber.length <= 4) return `(${areaCode}) ${subscriber}`;

  const prefixLength = subscriber.length > 8 ? 5 : 4;
  return `(${areaCode}) ${subscriber.slice(0, prefixLength)}-${subscriber.slice(prefixLength)}`;
}

export function formatIntegerInput(value: string | number): string {
  const digits = digitsOnly(String(value));
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
